export default __webpack_public_path__ + "img/v_img.74cc9d5e.svg";